/** Shown in workspace role switchers; inactive product roles stay out of the list. */
export const WORKSPACE_ROLE_EXCLUDE = new Set(['podcast_manager', 'zitius_ai']);

export function buildRoleOptionsFromContexts(allAccessibleContexts, currentContext) {
  const map = new Map();
  (allAccessibleContexts || []).forEach((c) => {
    const rn = String(c.role_name || '').toLowerCase();
    if (WORKSPACE_ROLE_EXCLUDE.has(rn)) return;
    if (!map.has(c.role_id)) {
      map.set(c.role_id, { role_id: c.role_id, role_name: c.role_name });
    }
  });
  let list = [...map.values()].sort((a, b) => String(a.role_name).localeCompare(String(b.role_name)));
  const curId = currentContext?.role_id;
  const curName = currentContext?.role_name;
  if (curId != null && curName != null) {
    const curKey = String(curName).toLowerCase();
    if (
      WORKSPACE_ROLE_EXCLUDE.has(curKey) &&
      !list.some((r) => Number(r.role_id) === Number(curId))
    ) {
      list = [...list, { role_id: curId, role_name: curName }].sort((a, b) =>
        String(a.role_name).localeCompare(String(b.role_name))
      );
    }
  }
  return list;
}

export function roleWorkspaceLabel(roleName, t) {
  const key = String(roleName || '').toLowerCase();
  if (key === 'athlete') return t('auth.roleAthlete');
  if (key === 'coach') return t('auth.roleCoach');
  if (key === 'podcast_manager') return t('auth.rolePodcastManager');
  if (key === 'zitius_ai') return t('dashboard.zitiusAi');
  if (key === 'platform_admin') return t('auth.rolePlatformAdmin');
  return roleName || '';
}
